import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2026 TravelBharat</p>
    </footer>
  );
};

export default Footer;